import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-white/70 py-10 text-center text-sm px-4 border-t border-brand-border" data-id="element-113">
      <p className="font-medium tracking-wide" data-id="element-114">
        © MEGAPACK CIENCIAS SOCIALES LISTA — Todos los derechos reservados
      </p>
    </footer>;
}